<template>
  <div class="main-desktop-navbar">
    <div class="main-desktop-navbar__menu">
      <template v-for="item in items" :key="item.label">
        <NavbarItemNode v-if="isNavbarOpened" :item :disabled />
        <NavbarItemMenu v-else :item :disabled />
      </template>
      <slot />
      <div class="main-desktop-navbar__footer">
        <NavbarNeedHelp />
        <slot name="footer" />
      </div>
    </div>
  </div>
  <slot name="after" />
</template>

<script setup lang="ts">
import { inject } from 'vue'

import { NavigationItem } from '@types'
import { OpenedFlag } from '../../utils/type'

import { NAVBAR_OPENED } from '../../utils/const'

import NavbarNeedHelp from './NavbarNeedHelp.vue'
import NavbarItemMenu from './NavbarItemMenu.vue'
import NavbarItemNode from './NavbarItemNode.vue'

type Props = {
  items?: NavigationItem[]
  disabled?: boolean
}

defineProps<Props>()

const isNavbarOpened = inject<OpenedFlag>(NAVBAR_OPENED)
</script>

<style>
.main-desktop-navbar {
  @apply w-[4.2rem];
  @apply flex flex-col items-center;
  @apply shrink-0;
  @apply py-2 gap-2;
  @apply bg-body-gray;
  @apply border-r border-common-border;
  @apply z-40;
  @apply transition-all;

  .main-desktop--opened-navbar & {
    @apply w-56;
    @apply items-start;
  }

  &__menu {
    @apply w-full;
    @apply flex flex-col;
    @apply flex-auto;
    @apply gap-2;

    .main-desktop--opened-navbar & {
      @apply w-full;
      @apply px-2 gap-[4px];
    }
  }

  &__footer {
    @apply mt-auto;
    @apply flex flex-col;
    @apply gap-2;
  }
}
</style>
